'use client';

import classnames from 'classnames';

import styles from 'molecules/Button/button.module.scss';
import Icon from 'molecules/Icon';

import parseUrl from 'utils/parseUrl';

import type { IconIds } from 'molecules/Icon';
import type { ButtonHTMLAttributes, FC, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
  children?: ReactNode;
  url?: string;
  direction?: 'left' | 'right';
  label?: string;
  iconId?: IconIds;
  textStyle?: string;
  textLink?: string;
  target?: string;
}

const Button: FC<ButtonProps> = ({
  label,
  children,
  className = '',
  url,
  target,
  color = 'gray',
  disabled = false,
  textStyle = '',
  textLink = '',
  direction = '',
  iconId,
  ...props
}) => {
  const classes = classnames(styles.button, {
    [styles.arrowButton]: direction,
    [styles[color]]: !disabled,
    [styles.disabled]: disabled,
    [styles[textStyle]]: textStyle,
    [styles.textLink]: textLink,
    [className]: className,
  });

  const { as, tabIndex: _tabIndex, ...parsedUrl } = parseUrl(url);
  const Component = url ? as : 'button';

  return (
    <Component
      className={classes}
      disabled={disabled}
      {...(url ? parsedUrl : {})}
      {...props}
      target={target || parsedUrl.target}
    >
      {(children || label) && <span>{children || label}</span>}
      {iconId && <Icon size={19} icon={iconId} />}
    </Component>
  );
};

export default Button;
